'use strict';
angular.module("logManageMentHeiMaLogRouterModule", [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider.
        state("manageconfig.logmanage.heimaLog", {
            url: '/heimaLog',
            views: {
                'main@manageconfig.logmanage': {
                    templateUrl: './manageConfig/logManageMent/heimaLog/heimaLog_tpl.html',
                    controller: 'logManageMentHeiMaLogCtrl',
                },
                'footer@manageconfig.logmanage': {
                    templateUrl: './footer_tpl.html'
                }
            }
        });
    }]);
